// Enhanced structured data for competitions and organization

export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Capstone Pakistan",
    "alternateName": "Capstone",
    "description": "Premier partner for international organizations conducting nationwide academic testing and competitions across Pakistan. We organize PMMC, WMTC, and PGEO competitions.",
    "url": "https://capstonepakistan.org",
    "logo": {
      "@type": "ImageObject",
      "url": "https://capstonepakistan.org/capstone-logo.svg",
      "width": 200,
      "height": 60
    },
    "image": "https://capstonepakistan.org/capstone-logo-large.svg",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "Pakistan",
      "addressRegion": "Punjab"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "admin@capstonepakistan.org",
      "contactType": "customer service",
      "availableLanguage": "English"
    },
    "sameAs": [
      "https://www.instagram.com/pmmcofficial/",
      "https://www.facebook.com/capstonepakistan",
      "https://twitter.com/capstonepakistan"
    ],
    "foundingDate": "2020",
    "numberOfEmployees": "10-50",
    "serviceArea": {
      "@type": "Country",
      "name": "Pakistan"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Academic Competitions",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pakistan Mathematical Modeling Challenge (PMMC)",
            "description": "National mathematical modeling competition for high school students"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "World Mathematics Team Championship (WMTC)",
            "description": "International team-based mathematics competition"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pakistan Geography Olympiad (PGEO)",
            "description": "National geography competition for students"
          }
        }
      ]
    }
  };
}

export function getCompetitionSchema(competition) {
  const baseUrl = "https://capstonepakistan.org";
  
  return {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": competition.name,
    "description": competition.description,
    "url": `${baseUrl}${competition.path}`,
    "image": competition.image ? `${baseUrl}${competition.image}` : `${baseUrl}/capstone-logo-large.svg`,
    "startDate": competition.startDate || "2024-01-01",
    "endDate": competition.endDate || "2024-12-31",
    "eventStatus": "https://schema.org/EventScheduled",
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
    "organizer": {
      "@type": "EducationalOrganization",
      "name": "Capstone Pakistan",
      "url": baseUrl
    },
    "location": {
      "@type": "Place",
      "name": "Pakistan",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "Pakistan"
      }
    },
    "audience": {
      "@type": "Audience",
      "audienceType": "Students",
      "educationalLevel": "High School"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "PKR",
      "availability": "https://schema.org/InStock",
      "validFrom": competition.registrationStart || "2024-01-01"
    }
  };
}

export function getBreadcrumbSchema(breadcrumbs) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": crumb.url
    }))
  };
}

export function getFAQSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
}

export function getTestimonialSchema(testimonials) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Student Testimonials",
    "description": "Testimonials from students who participated in Capstone Pakistan competitions",
    "itemListElement": testimonials.map((testimonial, index) => ({
      "@type": "Review",
      "position": index + 1,
      "author": {
        "@type": "Person",
        "name": testimonial.name,
        "affiliation": {
          "@type": "EducationalOrganization",
          "name": testimonial.school
        }
      },
      "reviewBody": testimonial.text,
      "itemReviewed": {
        "@type": "EducationalOrganization",
        "name": "Capstone Pakistan"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      }
    }))
  };
}

export function getArticleSchema(article) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.summary,
    "image": article.image ? `https://capstonepakistan.org${article.image}` : "https://capstonepakistan.org/capstone-logo-large.svg",
    "author": {
      "@type": "Organization",
      "name": "Capstone Pakistan"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Capstone Pakistan",
      "logo": {
        "@type": "ImageObject",
        "url": "https://capstonepakistan.org/capstone-logo.svg"
      }
    },
    "datePublished": article.publishedTime || "2024-01-01",
    "dateModified": article.modifiedTime || "2024-01-01",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://capstonepakistan.org/blogs"
    }
  };
}

export function getWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Capstone Pakistan",
    "url": "https://capstonepakistan.org",
    "description": "Premier academic competitions and mathematical modeling challenges in Pakistan",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://capstonepakistan.org/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };
} 